import { FC, PropsWithChildren, memo } from 'react';
import { BrandAffinityXAIContextProvider } from 'modules/ai/XAI/audienceUserProfile';
import { useUserMetadataQueryContext } from './contexts/UserMetadataQueryContext';
import { useUserKey } from 'modules/userProfiles/hooks';

export const ConnectedBAXAIProvider: FC<PropsWithChildren<unknown>> = memo(({ children }) => {
  const { emailAddress, brandAffinityLevel: brandAffinityLabel } = useUserMetadataQueryContext();
  const internalUserId = useUserKey(true);
  return (
    <BrandAffinityXAIContextProvider
      userUuidKey={internalUserId}
      userEmailKey={emailAddress}
      brandAffinityLabel={brandAffinityLabel}
    >
      {children}
    </BrandAffinityXAIContextProvider>
  );
});
